import { useEffect } from 'react'
import s from './AddPipeline.scss'
import { Col, Row, Button } from 'reactstrap'
import {
  KeyValuePairs,
  InputContainer,
  Checkbox,
  Spinner,
  ColorPicker
} from 'components/ideal-core-ui'
import Select from 'react-select'
import { toCategories } from '../serializers'
import cn from 'classnames'
import { useImmer } from 'use-immer'

const AddPipeline = ({
  stageCategories,
  pipelineDetails,
  error,
  isEdit,
  loading,
  resetForm,
  addPipeline,
  updatePipeline
}) => {
  const [pipeline, setPipeline] = useImmer({})

  useEffect(() => {
    if (pipelineDetails) {
      setPipeline(() => pipelineDetails)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pipelineDetails])

  const changeProperty = (value, property) => {
    setPipeline(state => {
      state[property] = value
    })
    if (property === 'category') {
      const category = stageCategories.find(c => c.id === value.value)
      setPipeline(state => {
        state.color = category.color
      })
    }
  }

  return (
    <div className={s.formWrapper}>
      <Col xl="12" className={s.form}>
        <Row>
          <Col lg="6">
            <KeyValuePairs
              pairs={[
                {
                  key: '* Name',
                  keyClass: [s.label],
                  valueClass: [s.value],
                  value: (
                    <InputContainer
                      type="text"
                      placeholder="Enter Stage Name"
                      cb={value => changeProperty(value.replace(/[^a-zA-Z0-9_-]/g, ''), 'name')}
                      text={pipeline.name}
                      isDisabled={pipeline.isSystem}
                      classname={cn({ [s.disabled]: pipeline.isSystem })}
                      cy="pipeline_name_input"
                    />
                  )
                }
              ]}
            />
            <span className={s.info}>
              This is the text that will be used by the app to identify the Stage Column. We&apos;ll
              remove any special characters and spaces.
            </span>
            <KeyValuePairs
              pairs={[
                {
                  key: '* Stage Label',
                  keyClass: [s.label],
                  valueClass: [s.value],
                  value: (
                    <InputContainer
                      type="text"
                      placeholder="Enter Stage Label"
                      cb={value => changeProperty(value, 'label')}
                      text={pipeline.label}
                      cy="pipeline_label_input"
                    />
                  )
                }
              ]}
            />
            <span className={s.info}>
              This is the text that will show on the Pipeline Board at the top of the Stage Column
            </span>
            <KeyValuePairs
              pairs={[
                {
                  key: '* Stage Category',
                  keyClass: [s.label],
                  valueClass: [s.value],
                  value: (
                    <Select
                      onChange={value => changeProperty(value, 'category')}
                      options={toCategories(stageCategories)}
                      value={pipeline.category}
                      className={s.select}
                      id="pipeline_category_select_cy"
                    />
                  )
                },
                {
                  key: 'Stage Color',
                  keyClass: [s.label],
                  valueClass: [s.value],
                  value: (
                    <div className={s.colorInputContainer}>
                      <ColorPicker
                        onChange={color => changeProperty(color, 'color')}
                        color={pipeline.color}
                      />
                    </div>
                  )
                }
              ]}
            />
          </Col>
          <Col lg="6">
            <KeyValuePairs
              pairs={[
                {
                  key: 'Visible on Pipeline Board',
                  keyClass: [s.label],
                  valueClass: [s.checkboxValue],
                  value: (
                    <Checkbox
                      isChecked={pipeline.visibleOnBoardLanes}
                      triggerCheckbox={value =>
                        changeProperty(value.target.checked, 'visibleOnBoardLanes')
                      }
                      name="visibleOnBoardLanes"
                    />
                  )
                }
              ]}
            />
            <span className={s.info}>
              In general, Pipeline Stages should be visible on the Board and in the status
              drop-down, but you can hide them if necessary.
            </span>
          </Col>
        </Row>
        {error && <p className={s.error}>{error}</p>}
        <div className={s.buttons}>
          <Button
            onClick={() => {
              isEdit ? updatePipeline(pipeline) : addPipeline(pipeline)
            }}
            className={s.saveBtn}
            data-cy="submit_btn"
          >
            {loading ? <Spinner /> : <>Save Changes</>}
          </Button>
          <Button onClick={resetForm}>Cancel</Button>
        </div>
      </Col>
    </div>
  )
}

export default AddPipeline
